export const getItem = (key, fallback = null) => {
  try {
    const value = sessionStorage.getItem(key);
    return value !== null ? value : fallback;
  } catch (_) {
    return fallback;
  }
};

export const setItem = (key, value) => {
  try {
    sessionStorage.setItem(key, value);
  } catch (_) {
    // no-op
  }
};

export const getJSON = (key, fallback = null) => {
  try {
    const raw = sessionStorage.getItem(key);
    if (raw === null) return fallback;
    return JSON.parse(raw);
  } catch (_) {
    return fallback;
  }
};

export const setJSON = (key, value) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (_) {
    // no-op
  }
};

export const getUser = () => {
  return (
    getJSON('user', {
      retake_status: '0',
      retake_permission: '0',
      course_status: '0',
      test_status: '0',
      name: '',
      email: ''
    }) || {}
  );
};


